import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { NavLink, withRouter } from 'react-router-dom'
import Headroom from 'react-headroom'
import 'gsap/umd/ScrollToPlugin'
import * as TweenLite from 'gsap/umd/TweenLite'

const isWorksActive = (match, location) => location.pathname.slice(0, 6) === '/works'

class Header extends Component {
  state = {
    menuOpened: false,
  }

  componentDidMount() {
    const y = window.innerWidth < 768 ? -54 : -100
    TweenLite.from(this.ref, 0.6, { y })
  }

  componentDidUpdate(prevProps) {
    const urlChanged = prevProps.location.pathname !== this.props.location.pathname
    if (urlChanged) {
      this.hideMenu()
    }
  }

  hideMenu = () => {
    document.querySelector('html').classList.remove('menu-opened')
    this.setState({ menuOpened: false })
  }

  handleLogoClick = (e) => {
    e.preventDefault()

    if (!isWorksActive(null, this.props.location)) {
      this.props.history.push(`/works/${this.props.firstSlug}`)
    }

    if (this.state.menuOpened) {
      this.closeMenu()
    }

    if (window.scrollY > 0) {
      TweenLite.to(window, 0.8, { scrollTo: 0 })
    }
  }

  handleMenuToggle = () => {
    if (this.state.menuOpened) {
      this.closeMenu()
    } else {
      this.openMenu()
    }
  }

  openMenu() {
    document.querySelector('html').classList.add('menu-opened')
    this.setState({ menuOpened: true })
  }

  closeMenu() {
    document.querySelector('html').classList.remove('menu-opened')
    const y = document.body.clientHeight * this.scrollPercent
    window.scrollTo(0, y)
    this.setState({ menuOpened: false })
  }

  render() {
    return (
      <Headroom>
        <header ref={(ref) => { this.ref = ref }}>
          {/* eslint-disable */}
          <h1><a href="" onClick={this.handleLogoClick}>Dusan Husar</a></h1>
          <div className="burger" onClick={this.handleMenuToggle}>
            <button>Menu</button>
          </div>
          {/* eslint-enable */}
          <nav className="menu">
            <ul>
              <li>
                <NavLink
                  activeClassName="active"
                  to={`/works/${this.props.firstSlug}`}
                  isActive={isWorksActive}
                >Works
                </NavLink>
              </li>
              <li><NavLink activeClassName="active" to="/contact">Contact</NavLink></li>
            </ul>
          </nav>
        </header>
      </Headroom>
    )
  }
}

Header.propTypes = {
  firstSlug: PropTypes.string.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
}

export default withRouter(Header)



// WEBPACK FOOTER //
// ./src/components/Header.js